import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import * as Feather from 'react-feather';
import DefaultInput from './DefaultInput';

const IconInput = (props) => {
  const { iconName, iconPosition, inputValue, placeholder, onChange, inputName, inputType, actionIcon } = props;
  const [__inputType, setInputType] = useState(inputType);
  const Icon = Feather[iconName];
  const ActionIcon = actionIcon ? Feather[actionIcon] : null;

  const toggleInputType = () => {
    setInputType(__inputType === inputType ? 'text' : inputType);
  };

  return (
    <InputGroup>
      <InputGroupAddon addonType={iconPosition}>
        <InputGroupText>
          <Icon />
        </InputGroupText>
      </InputGroupAddon>
      <DefaultInput
        inputValue={inputValue}
        placeholder={placeholder}
        onChange={onChange}
        inputName={inputName}
        inputType={__inputType} />

      { ActionIcon ? <ActionIcon onClick={() => toggleInputType()} className="action-icon" /> : null }
    </InputGroup>
  );
};

IconInput.defaultProps = {
  iconPosition: 'prepend'
};

IconInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  iconPosition: PropTypes.oneOf(['prepend', 'append']).isRequired,
  inputValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  inputType: PropTypes.string,
  actionIcon: PropTypes.string
};

export default IconInput;